/**
 * NetworkIndicator - Network status tile (mainnet/devnet)
 */
import React from 'react';

const NetworkIndicator = ({ network }) => (
  <div style={{
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: network === 'mainnet' ? '36px' : '30px',
    height: '28px',
    borderRadius: '2.5px',
    background: network === 'mainnet'
      ? 'linear-gradient(135deg, rgba(76, 175, 80, 0.4) 0%, rgba(46, 125, 50, 0.3) 30%, rgba(30, 123, 52, 0.25) 70%, rgba(20, 90, 37, 0.2) 100%)'
      : 'linear-gradient(135deg, rgba(220, 38, 38, 0.4) 0%, rgba(185, 28, 28, 0.3) 30%, rgba(153, 27, 27, 0.25) 70%, rgba(127, 29, 29, 0.2) 100%)',
    border: '0.5px solid rgba(255, 255, 255, 0.08)',
    boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.2), 0 1px 1px rgba(0, 0, 0, 0.1)',
    flexShrink: 0,
    overflow: 'hidden',
  }}>
    {/* Top highlight */}
    <div style={{
      position: 'absolute',
      top: '1px',
      left: '1px',
      right: '1px',
      height: '8px',
      borderRadius: '1.5px 1.5px 0 0',
      background: network === 'mainnet'
        ? 'linear-gradient(to bottom, rgba(129, 199, 132, 0.3) 0%, rgba(102, 187, 106, 0.15) 40%, transparent 100%)'
        : 'linear-gradient(to bottom, rgba(239, 68, 68, 0.3) 0%, rgba(220, 38, 38, 0.15) 40%, transparent 100%)',
      pointerEvents: 'none',
      zIndex: 1,
    }} />
    {/* Left highlight */}
    <div style={{
      position: 'absolute',
      top: '1px',
      left: '1px',
      width: '8px',
      bottom: '1px',
      borderRadius: '1.5px 0 0 1.5px',
      background: network === 'mainnet'
        ? 'linear-gradient(to right, rgba(129, 199, 132, 0.25) 0%, rgba(102, 187, 106, 0.1) 40%, transparent 100%)'
        : 'linear-gradient(to right, rgba(239, 68, 68, 0.25) 0%, rgba(220, 38, 38, 0.1) 40%, transparent 100%)',
      pointerEvents: 'none',
      zIndex: 1,
    }} />
    <span style={{
      fontSize: '9px',
      fontWeight: 600,
      color: network === 'mainnet' ? 'rgba(129, 199, 132, 0.9)' : 'rgba(239, 68, 68, 0.9)',
      textTransform: 'uppercase',
      letterSpacing: '0.8px',
      zIndex: 15,
      position: 'relative',
      fontFamily: 'system-ui, -apple-system, sans-serif',
    }}>
      {network === 'mainnet' ? 'Main' : 'Dev'}
    </span>
  </div>
);

export default NetworkIndicator;
